<div class="ad-popup-container">
  <div class="modal-header d-flex justify-content-between align-items-center gap-2">
    <h4 class="modal-title">Elefant Order Items</h4>

    <button type="button" aria-label="Close" data-bs-dismiss="ad-popup-container" class="ad-close-btn"
      (click)="activeModal.close()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m7 7l10 10M7 17L17 7"
          stroke-width="1"></path>
      </svg>
    </button>
  </div>

  <ng-template #orderListDiv></ng-template>



  <div class="ad-tab-container p-3">
    <ul ngbNav #nav="ngbNav" class="cus-scroll">
      <li ngbNavItem="pickup">
        <a class="btn ad-btn-small" ngbNavLink (click)="showLoader() ">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M4 2H20V6.45994L13.5366 12L20 17.5401V22H4V17.5401L10.4634 12L4 6.45994V2ZM12 10.6829L18 5.54007V4H6V5.54007L12 10.6829ZM12 13.3171L6 18.4599V20H18V18.4599L12 13.3171Z">
            </path>
          </svg>
          <span>Pickup List</span>
        </a>
        <ng-template ngbNavContent>
          @if(pickupCollectedItems().length == 0 && wholePickupItems().length == 0){
          <div class="h-100 w-100 modal-body ad-empty-data-for-live-orders">
            <app-empty-state illustration="order" title="No Data Found"></app-empty-state>
          </div>
          }

          @if(wholePickupItems().length > 0){
          <div class="pt-4">
            <h6 class="fw-bold mb-3 py-3">To be Picked up</h6>
            <div class="row g-3 pb-3">
              @for (item of wholePickupItems(); track $index) {
              <div class="col-1 ">
                <div class="custom-card p-0 cus-img   w-80px">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />
                </div>
              </div>
              }
            </div>
          </div>
          }
          @if(pickupCollectedItems().length > 0){
          <h6 class="fw-bold mb-3 py-3">Picked up Item's</h6>

          <div class="row g-3 pb-3">
            @for (item of pickupCollectedItems(); track $index) {
            <div class="col-md-3 col-sm-6">
              <div class="custom-card p-0 ">
                <img [src]="item.image || 'assets/images/no-image.png'"
                  (error)="$any($event.target).src='assets/images/no-image.png'" />
                <div class="card-body-custom ">
                  <div class="d-flex justify-content-between small-text flex-wrap flex-md-nowrap gap-2">
                    <!-- <span class="text-nowrap">
                      Order ID :
                      <b class="text-dark">{{ item.order_id }}</b>
                    </span> -->

                    <span class="text-nowrap">
                      Code :
                      <b class="text-dark">{{ item.item_code }}</b>
                    </span>
                  </div>

                  <div class="product-title">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </ng-template>
      </li>
      <li ngbNavItem="delivered">
        <a class="btn ad-btn-small mx-2" ngbNavLink (click)="showLoader() ">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L13.0001 11.4234V20.11L19.5 16.3469V7.65311L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329Z">
            </path>
          </svg>
          <span>Delivered List</span>
        </a>
        <ng-template ngbNavContent>
          @if(deliveredItems().length == 0){
          <div class="h-100 w-100 modal-body ad-empty-data-for-live-orders">
            <app-empty-state illustration="order" title="No Data Found"></app-empty-state>
          </div>
          }
          @if(deliveredItems().length > 0){
          <div class="pt-4">
            <h6 class="fw-bold mb-3 py-3">Delivered Item's</h6>

            <div class="row g-3 pb-3">
              @for (item of deliveredItems(); track $index) {
              <div class="col-md-3 col-sm-6">
                <div class="custom-card p-0">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />

                  <div class="card-body-custom">
                    <div class="d-flex justify-content-between small-text flex-wrap flex-md-nowrap gap-2">
                      <span class="text-nowrap">
                        Order ID :
                        <b class="text-dark">{{ item.order_id }}</b>
                      </span>

                      <span class="text-nowrap">
                        Code :
                        <b class="text-dark">{{ item.item_code }}</b>
                      </span>
                    </div>

                    <div class="product-title">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }

        </ng-template>
      </li>
      <li ngbNavItem="deliveryCollected">
        <a class="btn ad-btn-small mx-2" ngbNavLink (click)="showLoader() ">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z">
            </path>
          </svg>
          <span>Collection at Delivery List </span>
        </a>
        <ng-template ngbNavContent>
          @if(deliveryCollectedItems().length == 0 && wholeDeliveryItems().length == 0){
          <div class="h-100 w-100 modal-body ad-empty-data-for-live-orders">
            <app-empty-state illustration="order" title="No Data Found"></app-empty-state>
          </div>
          }
          @if(wholeDeliveryItems().length > 0){
          <div class="pt-4">
            <h6 class="fw-bold mb-3 py-3">Collection Item's</h6>
            <div class="row g-3 pb-3">
              @for (item of wholeDeliveryItems(); track $index) {
              <div class="col-1 ">
                <div class="custom-card p-0 cus-img w-80px ">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />
                </div>
              </div>
              }
            </div>
          </div>
          }
          @if(deliveryCollectedItems().length > 0){
          <div class="pt-4">
            <h6 class="fw-bold mb-3 py-3">Collected Item's</h6>
            <div class="row g-3 pb-3">
              @for (item of deliveryCollectedItems(); track $index) {
              <div class="col-md-3 col-sm-6">
                <div class="custom-card p-0   ">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />

                  <div class="card-body-custom">
                    <div class="d-flex justify-content-between small-text flex-wrap flex-md-nowrap gap-2">
                      <!-- <span class="text-nowrap">
                        Order ID :
                        <b class="text-dark">{{ item.order_id }}</b>
                      </span> -->

                      <span class="text-nowrap">
                        Code :
                        <b class="text-dark">{{ item.item_code }}</b>
                      </span>
                    </div>

                    <div class="product-title">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </ng-template>
      </li>
      <li ngbNavItem="rto-delivered">
        <a class="btn ad-btn-small" ngbNavLink (click)="showLoader() ">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M4.00488 16V4H2.00488V2H5.00488C5.55717 2 6.00488 2.44772 6.00488 3V15H18.4433L20.4433 7H8.00488V5H21.7241C22.2764 5 22.7241 5.44772 22.7241 6C22.7241 6.08176 22.7141 6.16322 22.6942 6.24254L20.1942 16.2425C20.083 16.6877 19.683 17 19.2241 17H5.00488C4.4526 17 4.00488 16.5523 4.00488 16ZM6.00488 23C4.90031 23 4.00488 22.1046 4.00488 21C4.00488 19.8954 4.90031 19 6.00488 19C7.10945 19 8.00488 19.8954 8.00488 21C8.00488 22.1046 7.10945 23 6.00488 23ZM18.0049 23C16.9003 23 16.0049 22.1046 16.0049 21C16.0049 19.8954 16.9003 19 18.0049 19C19.1095 19 20.0049 19.8954 20.0049 21C20.0049 22.1046 19.1095 23 18.0049 23Z">
            </path>
          </svg>
          <span>RTO Delivery</span>
        </a>
        <ng-template ngbNavContent>
          @if( rtoDeliveryItems().length == 0 ){
          <div class="h-100 w-100 modal-body ad-empty-data-for-live-orders">
            <app-empty-state illustration="order" title="No Data Found"></app-empty-state>
          </div>
          }
          @if(rtoDeliveryItems().length > 0){
          <div class="pt-4">
            <h6 class="fw-bold mb-3 py-3">RTO Delivered Item's</h6>
            @if(rtoDeliveredPickupItems().length > 0){
            <div class="row g-3 ">
              <h6 class="fw-bold mb-3 py-3">Returned (Undelivered) Items</h6>

              @for (item of rtoDeliveredPickupItems(); track $index) {

              <div class="col-md-3 col-sm-6">
                <div class="custom-card p-0 ">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />

                  <div class="card-body-custom">
                    <div class="d-flex justify-content-between small-text flex-wrap flex-md-nowrap gap-2">
                      <!-- <span class="text-nowrap">
                        Order ID :
                        <b class="text-dark">{{ item.order_id }}</b>
                      </span> -->

                      <span class="text-nowrap">
                        Code :
                        <b class="text-dark">{{ item.item_code }}</b>
                      </span>
                    </div>

                    <div class="product-title">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            }
            @if(rtoDeliveredDeliveryItems().length > 0){
            <div class="row g-3 ">
              <h6 class="fw-bold mb-3 py-3">Collected Items (From Customer)</h6>

              @for (item of rtoDeliveredDeliveryItems(); track $index) {
              <div class="col-md-3 col-sm-6">
                <div class="custom-card p-0 ">
                  <img [src]="item.image || 'assets/images/no-image.png'"
                    (error)="$any($event.target).src='assets/images/no-image.png'" />

                  <div class="card-body-custom">
                    <div class="d-flex justify-content-between small-text flex-wrap flex-md-nowrap gap-2">
                      <!-- <span class="text-nowrap">
                        Order ID :
                        <b class="text-dark">{{ item.order_id }}</b>
                      </span> -->

                      <span class="text-nowrap">
                        Code :
                        <b class="text-dark">{{ item.item_code }}</b>
                      </span>
                    </div>

                    <div class="product-title">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
            }
          </div>
          }

        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav">
    </div>
  </div>

</div>